import React from 'react';

const IntegrationsList = ({ integrations, onDelete, onToggleStatus, onEdit }) => {
  if (!integrations || integrations.length === 0) {
    return (
      <div className="flex justify-center items-center h-48">
        <p className="text-gray-500">No Integrations just yet</p>
      </div>
    );
  }

  return (
    <div className="divide-y">
      {integrations.map(integration => (
        <div key={integration.id} className="py-4 px-6 flex items-center justify-between">
          <div className="flex items-center">
            {/* Integration Logo */}
            <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center mr-4">
              <span className="text-lg font-bold">{integration.name.charAt(0)}</span>
            </div>

            {/* Integration Details */}
            <div>
              <h3 className="font-medium text-gray-900">{integration.name}</h3>
              <p className="text-sm text-gray-500">{integration.type}</p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-3">
            {/* Status Toggle */}
            <div className="flex items-center mr-2">
              <label className="inline-flex relative items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={integration.status === 'active'}
                  onChange={() => onToggleStatus(integration.id, integration.status === 'active' ? 'inactive' : 'active')}
                />
                <div className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer ${integration.status === 'active' ? 'peer-checked:after:translate-x-full peer-checked:bg-primary-500' : ''} after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all`}></div>
                <span className="ml-2 text-sm font-medium text-gray-700">
                  {integration.status === 'active' ? 'Active' : 'Inactive'}
                </span>
              </label>
            </div>

            {/* Settings Button */}
            <button
              onClick={() => onEdit(integration)}
              className="text-gray-500 hover:text-gray-800 transition p-1 rounded-full hover:bg-gray-100"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </button>

            {/* Delete Button */}
            <button
              onClick={() => onDelete(integration.id)}
              className="text-gray-500 hover:text-red-600 transition p-1 rounded-full hover:bg-gray-100"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default IntegrationsList;

